import { get } from './apiCall';
const getLocationMenu = async function(locationId) {
        const locationMenuResponse = await get(`/locations/${locationId}/menu`);
        return locationMenuResponse.data;
}
export default getLocationMenu;